define('presentation/settings/integrations/facades/addClioGrowTokenModalFacade',[
    'persistence/webSocket/webSocketApp'
], function() {
    return function() {
        const self = this;

        let _promiseFactory = null;
        let _webSocketApp = null;

        const clientWebSocket = require('externalDependencies/clientWebSocket');
        const integrationSocket = clientWebSocket.forApplication("integrations");

        self.saveClioGrowToken = (token) => {
            return _promiseFactory.defer((promise) => {
                const params = {
                    platform: 'clioGrow',
                    authorizationCode: token
                };

                integrationSocket.send("connect", params, (response) => {
                    promise.resolve();
                });
            });
        };

        self.init = (promiseFactory) => {
            _promiseFactory = promiseFactory;

            const WebSocketAppConstruction = require('persistence/webSocket/webSocketApp');
            _webSocketApp = new WebSocketAppConstruction();
            _webSocketApp.init("integrations");
        };
    };
});

